import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import OrderDashboard from '../../../models/OrderDashboard';
import environments from '../../../configs/environments';
import ghaDashboardStyles from '../../gha/dashboard/ghaDashboard.module.css';

import DriverQueue, { DriverQueueState, ResultDriverQueue } from '../../../models/DriverQueue';
import User from '../../../models/User';
import GhaDashboard from '../../gha/dashboard/GhaDashboard';
import Counter from '../../../models/Counter';

interface GhaDashboardContainerProps {
  receiveError: Function;
  user: User;
  driverQueueState: DriverQueueState;
  counters: Array<Counter>;
  dashboardCounters: Array<any>;
  setCounters: (counters: any[]) => void;
};
  
interface GhaDashboardContainerState {
  pos: Array<OrderDashboard>;
  completed: boolean;
  dropOff: boolean;
  pickups: boolean;
  queue: Array<DriverQueue>;
  serving: Array<DriverQueue>;
  waitTime: number;
  counterAirlines: Array<string>;
};

let height: number = 0;
let i = 1;
let j = 1;

class GhaDashboardContainer extends Component<GhaDashboardContainerProps, GhaDashboardContainerState> {

  intervalID: number | undefined;

  state = {
    pos: [],
    completed: true,
    dropOff: true,
    pickups: true,
    queue: [],
    serving: [],
    waitTime: 0,
    counterAirlines: []
  };

  componentDidMount() {
    height = this.getWindowDimensions();
    this.toggleShowDashboard();
    this.intervalID = window.setInterval(
      () => {
        this.toggleShowDashboard();
      },
      environments.refreshInterval
    );
  }
  

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  componentDidUpdate(prevProps: GhaDashboardContainerProps) {
    if(prevProps.driverQueueState.whsQueue.length === 0 && this.props.driverQueueState.whsQueue.length > 0) {
      this.toggleShowDashboard()
    }
  }

  paginate = (queue: Array<DriverQueue>, page_size: number, page_number: number): DriverQueue[] => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return queue.slice((page_number - 1) * page_size, page_number * page_size);
  }

  toggleShowDashboard = (): void => {
    let count = 13;
    let servingCount = 4;
    if(height <= 1200) {
      count = 10;
    } else if(height > 1500) {
      count = 15;
      servingCount = 5;
    }
    const pages = Math.ceil(this.props.driverQueueState.whsQueue.length / count);
    if(i > pages) {
      i = 1;
    }
    const newQueue = this.paginate(this.props.driverQueueState.whsQueue, count, i);
    i++;
    const servingPages = Math.ceil(this.props.driverQueueState.whsServing.length / servingCount);
    if(j > servingPages) {
      j = 1;
    }
    const newServingList = this.paginate(this.props.driverQueueState.whsServing, servingCount, j);
    i++;
    j++;
    this.setState({ queue: newQueue, serving: newServingList });
  }

  loadPickupOrders = ():void => {
    const currentDate: string = moment().format('YYYYMMDD');

    pickupOrderRemote.getPickupOrdersGha(null, currentDate, currentDate, '', '', '', true, this.state.completed, undefined, this.state.dropOff, this.state.pickups).then((resp: ApiResponse<Array<OrderDashboard>>) => {

      const pos: Array<OrderDashboard> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (pos) {
        this.setState({ pos });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return height;
  }


  filterOrdersType = (type: string): void => {
    const poList = [...this.state.pos];
    if(type === 'do') {
      const filteredList = poList.filter((po: OrderDashboard) => {  
        if(po.proc === 'Exp') {
          return po.proc !== 'Exp';
        } else {
          return po;
        }
      });
      this.setState({ pos: filteredList, dropOff: !this.state.dropOff }, () => {
        this.loadPickupOrders();
      }); 
    } else {
      const filteredList = poList.filter((po: OrderDashboard) => {  
        if(po.proc === 'Imp') {
          return po.proc !== 'Imp';
        } else {
          return po;
        }
      });
      this.setState({ pos: filteredList, pickups: !this.state.pickups }, () => {
        this.loadPickupOrders();
      });
    }
 
  }


  handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    let countersSelected = [...this.props.dashboardCounters];
    const value: any = event.target.value;
    let counterAirlines: string[] = [];
  
    if (value.includes('selectAll')) {
      // Handle 'Select All' option
      countersSelected = this.props.counters.map((counter) => counter.id);
      counterAirlines = this.props.counters.reduce((acc: any, counter) => {
        if ('airlines' in counter.info) {
          acc.push(...counter.info.airlines);
        }
        return acc;
      }, []);
    } else {
      // Check if 'Select All' is currently selected
      const selectAllIndex = countersSelected.indexOf('selectAll');
      counterAirlines = this.props.counters.reduce((acc: any, counter) => {
        if ('airlines' in counter.info) {
          acc.push(...counter.info.airlines);
        }
        return acc;
      }, []);
      if (selectAllIndex !== -1) {
        // If 'Select All' was selected, remove it
        countersSelected.splice(selectAllIndex, 1);
      }

      countersSelected = value;
    }
    this.setState({ counterAirlines });
    this.props.setCounters(countersSelected);
  };

  render() {
    
    return (
      <div className={ ghaDashboardStyles.parent }>
        <GhaDashboard
          filterOrderType={ this.filterOrdersType }
          queue={ this.state.queue }
          serving={ this.props.driverQueueState.whsServing }
          waitTime={ this.props.driverQueueState.whsWt }
          type='whs'
          counters={ this.props.counters }
          handleChange={ this.handleChange }
          countersSelected={ this.props.dashboardCounters }
          counterData={ this.state.counterAirlines }
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    driverQueueState: state.driverQueue,
    counters: state.countersAvailable
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(GhaDashboardContainer);